import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import SmallBreadcrumbs from '../../../components/layout/navigation/components/SmallBreadcrumbs'

const tooltip = (
  <Tooltip id="reset-widgets-suggestion">
    <i className="text-warning fa fa-warning" /> Warning! This will reset all
    your widget settings.
  </Tooltip>
)

export default () =>
  <div id="ribbon">
    <SmallBreadcrumbs />
  </div>
